import AppImage from '@theme/components/atom/AppImage'
import AppLink from '@theme/components/atom/AppLink'
import VerticalMenu from '~/themes/base/components/shop/VerticalMenu'

export default {
  extends: VerticalMenu,
  components: { AppImage, AppLink },
  props: {
    sectionLinks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    activeSection() {
      return this.currentBreadcrumbs && this.currentBreadcrumbs.length ? this.currentBreadcrumbs[0] : null
    },
    hasSectionNavigation() {
      return Boolean(this.activeSection && this.sectionLinks.length)
    },
    activeSectionIndex() {
      return this.sectionLinks.findIndex(section => this.isActiveSection(section))
    },
    sectionLinksBeforeActive() {
      return this.activeSectionIndex > 0 ? this.sectionLinks.slice(0, this.activeSectionIndex) : []
    },
    sectionLinksAfterActive() {
      return this.activeSectionIndex >= 0 ? this.sectionLinks.slice(this.activeSectionIndex + 1) : this.sectionLinks
    },
    sectionOpenIcon() {
      return require('@icon/arrow-down-box.svg?raw')
    },
    sectionLinkIcon() {
      return require('@icon/arrow-right.svg?raw')
    },
  },
  methods: {
    isActiveSection(section) {
      if (!this.activeSection) {
        return false
      }
      if (section === this.activeSection) {
        return true
      }
      if (section.id && this.activeSection.id) {
        return section.id === this.activeSection.id
      }
      return section.path === this.activeSection.path
    },
  },
}
